import React from "react";
import Meta from "./../components/Meta";
import DashboardSection from "./../components/DashboardSection";
import { requireAuth, useAuth } from "./../util/auth";
import { useRouter } from "./../util/router";
import IntroModal from "./../components/IntroModal";
import { useTranslation} from 'react-i18next';

function DashboardPage(props) {
  
  const auth = useAuth();
  const router = useRouter();

  const { t } = useTranslation();

  return (
    <>
    <Meta title={t("meta.dashboard.title")} />
    { !auth.user.name && <IntroModal /> } 
    { auth.user.name &&
      <DashboardSection
        bgColor="default"
        size="medium"
        bgImage=""
        bgImageOpacity={1}
        title={t("dashboard.headline") + auth.user.name}
        subtitle=""
        invite={router.query.invite}
        connection={router.query.connection}
        ttb={router.query.ttb}
        psb={router.query.psb}
      />
    }
    </>
  );
}

export default requireAuth(DashboardPage);
